var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21C20.5228 21 25 16.5228 25 11C25 5.47715 20.5228 1 15 1C9.47715 1 5 5.47715 5 11C5 16.5228 9.47715 21 15 21Z",
    fill: "#E31335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29C15.5228 29 20 24.5228 20 19C20 13.4772 15.5228 9 10 9C4.47715 9 0 13.4772 0 19C0 24.5228 4.47715 29 10 29Z",
    fill: "#282828",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29C25.5228 29 30 24.5228 30 19C30 13.4772 25.5228 9 20 9C14.4772 9 10 13.4772 10 19C10 24.5228 14.4772 29 20 29Z",
    fill: "#282828",
    fillOpacity: 0.376471
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombo);
export default __webpack_public_path__ + "static/media/combo.98c12e4f6e9f352b8a7e092b50087f91.svg";
export { ForwardRef as ReactComponent };